const translations = {
  en: {
    // App
    app_name: "CO2ePortal",
    // Auth
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Name",
    logout: "Logout",
    admin_panel: "Admin Panel",
    back_to_clients: "Back to Clients",
    assets_title: "Assets",
    assets_desc: "Manage buildings and properties for this client. Each asset has its own energy data and audit profile.",
    add_asset: "Add Asset",
    new_asset: "New Asset",
    edit_asset: "Edit Asset",
    // Roles
    role_admin: "admin",
    role_auditor: "auditor",
    // Client Selector
    select_client: "Select a Client",
    select_client_subtitle: "Choose a client to begin auditing.",
    add_new_client: "Add New Client",
    no_clients_yet: "No clients yet",
    create_first_client: "Create your first client to get started.",
    company_name: "Company Name",
    address: "Address",
    city: "City",
    zip_code: "Zip Code",
    country: "Country",
    contact_name: "Contact Name",
    phone: "Phone",
    website: "Website",
    save: "Save",
    cancel: "Cancel",
    create_new_client: "Create New Client",
    // Dashboard
    select_department: "Select Department to Audit",
    select_department_subtitle: "Choose a department to begin or continue its audit. Mark departments as \"Not Applicable\" if they don't apply to this client's business.",
    no_departments_title: "No departments for this building",
    no_departments_for_asset: "{asset} has no departments assigned yet. A department appears here once inventory or meter data is filed against this building.",
    no_departments_for_client: "This client has no departments assigned yet. A department appears here once inventory or meter data is filed against one of its buildings.",
    not_applicable: "Not Applicable",
    not_started: "not started",
    in_progress: "in progress",
    completed: "completed",
    complete: "Complete",
    // Sidebar
    audit_progress: "Audit Progress",
    depts: "depts",
    depts_na: "dept(s) N/A",
    main: "Main",
    dashboard: "Dashboard",
    inventory_upload: "Inventory Upload",
    energy_data_upload: "Energy Data Upload",
    energy_data_upload_desc: "Upload historical billing, thermal analysis, and gas billing files for the DPB-INIT-EMS calibration pipeline.",
    energy_vec_electrical: "Historical Electrical Billing",
    energy_vec_electrical_desc: "Hydro-Québec billing export (up to 12 months) — fallback/cross-check source, distinct from live IoT data.",
    energy_vec_thermal: "Building Thermal Analysis",
    energy_vec_thermal_desc: "Theoretical/simulated building energy model (envelope, HVAC, monthly consumption).",
    energy_vec_gas: "Gas Billing — Énergir",
    energy_vec_gas_desc: "Énergir invoice data with irregular billing periods — the only real-data source for the gas vector.",
    energy_thermal_mapping_title: "Column Mapping Required",
    energy_thermal_mapping_desc: "Select which columns contain the month and the theoretical value. Preview the first rows below.",
    iot_data: "IoT Data",
    data_comparison: "Data Comparison",
    consolidated_results: "Consolidated Results",
    energy_report: "Energy Efficiency Report",
    co2_report: "CO2e Emissions Report",
    departments: "Departments",
    navigation: "Navigation",
    back: "Back",
    // Department Audit
    audit: "Audit",
    save_all_answers: "Save All Answers",
    saving: "Saving...",
    questions_answered: "questions answered",
    of: "of",
    // Question types
    select_option: "-- Select --",
    yes: "Yes",
    no: "No",
    enter_value: "Enter value...",
    enter_answer: "Enter your answer...",
    dynamic: "Dynamic",
    // Energy Summary
    energy_co2_title: "Energy Efficiency & CO2 Emissions Estimate",
    energy_co2_empty: "Fill in numeric questions (kWh, kW) to see real-time energy and emissions estimates.",
    total_energy_kwh: "Total Energy (kWh)",
    total_power_kw: "Total Power (kW)",
    est_co2_kg: "Est. CO2 (kg)",
    hours_full_load: "Hours at Full Load",
    breakdown_by_section: "Breakdown by Section",
    section: "Section",
    energy_kwh: "Energy (kWh)",
    power_kw: "Power (kW)",
    co2_kg: "CO2 (kg)",
    // Observations
    auditor_observations: "Auditor Observations",
    observations_subtitle: "Notes, findings, and recommendations for this department audit.",
    observations_placeholder: "Enter observations, notes, or recommendations for this department audit...",
    // Inventory
    upload_inventory: "Upload Inventory File",
    upload_csv_xlsx: "Upload a CSV or Excel file with inventory data.",
    select_department_label: "Select Department",
    upload: "Upload",
    uploading: "Uploading...",
    equipment: "Equipment",
    department: "Department",
    power_rating: "Power Rating",
    energy_consumed: "Energy Consumed",
    cost: "Cost",
    co2_emission: "CO2 Emission",
    no_inventory: "No inventory data yet. Upload a file to get started.",
    // IoT
    iot_title: "IoT Data — PMC-53A-E Power Meter",
    iot_subtitle: "Simulated real-time readings from CET PMC-53A-E power meters.",
    simulate: "Simulate Readings",
    simulating: "Simulating...",
    latest_readings: "Latest Readings",
    no_iot: "No IoT data yet. Click \"Simulate Readings\" to generate PMC-53A-E data.",
    // Comparison Dashboard
    comparison_title: "Data Comparison Dashboard",
    comparison_subtitle: "3-way analysis: Inventory File vs IoT (PMC-53A-E) vs Department Audit results",
    refresh: "Refresh",
    no_discrepancies: "No significant discrepancies detected between data sources. Upload inventory data and simulate IoT readings to enable comparison.",
    discrepancies_detected: "Discrepanc(ies) Detected",
    high: "High",
    medium: "Medium",
    departments_compared: "Departments Compared",
    discrepancies: "Discrepancies",
    high_severity: "High Severity",
    inv_vs_iot_vs_audit: "Inventory vs IoT vs Audit — By Department",
    audit_pct: "Audit %",
    inv_energy: "Inv. Energy (kWh)",
    inv_power: "Inv. Power (kW)",
    iot_energy: "IoT Energy (kWh)",
    iot_power: "IoT Power (kW)",
    iot_pf: "IoT PF",
    iot_v_avg: "IoT V (avg)",
    energy_var: "Energy Var. %",
    status: "Status",
    alert: "Alert",
    ok: "OK",
    energy_comparison_chart: "Energy Comparison: Inventory vs IoT (kWh)",
    power_comparison_chart: "Active Power: Inventory vs IoT (kW)",
    inventory: "Inventory",
    iot_pmc: "IoT (PMC-53A-E)",
    inventory_kw: "Inventory (kW)",
    iot_kw: "IoT (kW)",
    pmc_readings_title: "IoT PMC-53A-E Meter Readings by Department",
    active_power: "Active Power",
    energy_total: "Energy Total",
    power_factor: "Power Factor",
    voltage_avg: "Voltage (avg)",
    current_avg: "Current (avg)",
    no_iot_readings: "No IoT readings — run simulation first",
    // Consolidated
    // Energy Data (CEP) — Data Comparison / Consolidated
    cep_title: "Energy Data (CEP)",
    cep_subtitle: "Calendar-normalized billing and thermal data for this building. Each vector keeps its own unit — nothing is summed across them.",
    cep_no_data: "No energy data has been processed yet. Upload a file in Energy Data Upload.",
    cep_electrical: "Electrical (billed)",
    cep_gas: "Gas (billed)",
    cep_thermal: "Thermal (modelled)",
    cep_coverage: "Coverage",
    cep_months: "months",
    cep_peak_demand: "Peak billed demand",
    cep_not_uploaded: "Not uploaded",
    cep_missing_electrical_months: "months with no electrical data",
    cep_vector_absent: "No file uploaded for this vector.",
    cep_by_building: "By building",
    cep_co2_withheld: "CO2 from metered energy",
    // Upward reconciliation
    recon_title: "Upward Reconciliation",
    recon_subtitle: "The departments in this building are summed and compared against the building's metered total. There is no downward split.",
    recon_reference: "Metered total (CEP electrical)",
    recon_bottom_up: "Bottom-up sum",
    recon_difference: "Difference",
    recon_ratio: "Ratio",
    recon_period: "Billing period",
    recon_basis: "Basis",
    recon_not_comparable: "Not comparable",
    recon_not_comparable_note: "Shown as arithmetic only. The two sides measure different things, so this difference is not treated as a discrepancy and raises no alert.",
    recon_inventory_vs_cep: "Inventory vs metered",
    recon_iot_vs_cep: "IoT vs metered",
    recon_no_reference: "No metered electrical total to compare against.",
    recon_depts_counted: "departments summed",
    // Excluded departments
    excluded_title: "Excluded from the table above",
    excluded_subtitle: "These departments are marked Not Applicable for the client, so they are not shown as rows. Their inventory and meter rows ARE still counted in the reconciliation above, because the building's metered total includes them.",
    excluded_has_data: "has data in this building",
    excluded_no_data: "no data in this building",
    excluded_counted: "Counted in reconciliation",
    // Scope labels and caveats
    scope_building: "This building",
    scope_client: "All buildings",
    scope_asset_note: "Counts cover the departments in the selected building.",
    scope_client_note: "Counts cover every department for this client.",
    audit_scope_note: "Audit status and Not Applicable are recorded per client, not per building — the same department shows the same status in every building.",
    na_scope_note: "Not Applicable is a client-wide flag. A department marked N/A is excluded from every building's count, so this denominator is not a judgement about this building.",
    no_per_dept_energy: "No per-department figure",
    reason_allocation_share_missing: "No per-department allocation share exists. A building's metered consumption cannot be split across its departments without one, and no verified source for those shares exists. Reconciliation runs upward instead.",
    reason_emission_factor_unresolved: "Withheld: the grid intensity factor is unresolved and blocked pending a verified source, so no CO2 figure is derived from metered energy.",
    reason_no_cep_data: "No energy data has been processed for this building yet.",
    reason_no_electrical_cep_data: "No electrical billing data for this building. Electrical kWh is the only metered quantity the bottom-up totals can be compared against — gas is in cubic metres and thermal is modelled.",
    reason_inventory_period_undeclared: "Inventory energy carries no period. Each row's kWh comes from the uploaded spreadsheet with no billing window attached, so it cannot be matched to the metered months.",
    reason_iot_register_snapshot: "IoT energy is the meter's latest register reading, not consumption during the metered months, so it measures a different quantity than the billing total.",
    consolidated_title: "Consolidated Results",
    consolidated_subtitle: "Combined analysis from all data sources.",
    audits_completed: "Audits Completed",
    equipment_items: "Equipment Items",
    total_energy: "Total Energy (kWh)",
    total_cost: "Total Cost",
    co2_emissions: "CO2 Emissions (kg)",
    audit_completion_dept: "Audit Completion by Department",
    completion: "Completion",
    avg_iot_power: "Avg IoT Power (kW)",
    energy_by_dept: "Energy by Department",
    co2_by_dept: "CO2 by Department",
    // Reports
    energy_report_title: "Energy Efficiency Report",
    energy_report_subtitle: "Energy consumption, power ratings, and efficiency analysis across all departments.",
    co2_report_title: "CO2e Emissions Report",
    co2_report_subtitle: "Carbon footprint analysis, emission factors, and environmental impact assessment.",
    generated: "Generated",
    download_report: "Download Report",
    download_excel: "Download Excel Report",
    client_information: "Client Information",
    company: "Company",
    contact: "Contact",
    dept_overview: "Department Overview",
    recommendations: "Recommendations",
    energy_metrics: "Energy Metrics",
    efficiency_analysis: "Efficiency Analysis",
    emission_breakdown: "Emission Breakdown",
    total_carbon_footprint: "Total Carbon Footprint",
    dept_emissions: "Department Emissions",
    // Alerts
    alerts: "Alerts",
    threshold_alerts: "Threshold Alerts",
    no_alerts: "All metrics within acceptable thresholds.",
    alert_pf_low: "Power Factor below threshold",
    alert_energy_high: "Energy consumption exceeds threshold",
    alert_co2_high: "CO2 emissions exceed threshold",
    threshold_settings: "Threshold Settings",
    pf_threshold: "Min Power Factor",
    energy_threshold: "Max Energy (kWh)",
    co2_threshold: "Max CO2 (kg)",
    save_thresholds: "Save Thresholds",
    // IoT enhanced
    sensor_readings: "Sensor Readings",
    upload_data: "Data Upload",
    meters: "Meters",
    no_meters: "No PMC-53A-E meters detected yet. Simulate data or upload a meter export file.",
    source: "Source",
    readings: "Readings",
    last_reading: "Last Reading",
    drop_pmc_file: "Drop PMC-53A-E export file here or click to browse",
    pmc_register_map: "PMC-53A-E Accepted Column Names",
    click_simulate: "Click \"Simulate Data\" to generate readings",
    // Live Monitor
    live_monitor: "Live Monitor",
    all_departments: "All Departments",
    pause: "Pause",
    resume: "Resume",
    last_update: "Last update",
    data_points: "data points",
    current_values: "Current Values",
    voltage_phase: "Voltage (3-Phase)",
    current_phase: "Current (3-Phase)",
    power_metrics: "Power Metrics",
    quality_metrics: "Power Quality",
    energy_trend: "Energy Consumption Trend",
    harmonic_distortion: "Harmonic Distortion",
    no_timeseries: "No time-series data available",
    simulate_or_push: "Simulate data or push readings from PMC-53A-E to see live trends.",
    // Commercial pipeline — step labels are keyed `step_{step key}` so the nav
    // can label a catalog step without the catalog carrying translations. An
    // uncatalogued key falls back to the API title (see utils/pipelineNav.js).
    // step_mb_pinn is the product-facing name; the key stays mb_pinn.
    step_dashboard: "Dashboard",
    step_inventory_upload: "Inventory Upload",
    step_energy_data_upload: "Energy Data Upload",
    step_retscreen_validation: "RETScreen Validation",
    step_iot_data: "IoT Data",
    step_mb_pinn: "Pulse Sync",
    step_data_comparison: "Data Comparison",
    step_consolidated_results: "Consolidated Results",
    step_sire: "SIRE",
    step_eevc_co2e_report: "EEVC + CO2e Emissions Report",
    // Nav-only override, keyed `step_nav_{step key}`: the sidebar is 260px, so
    // step 10 gets a shortened label there while the catalog title and the
    // detail pane keep the full one. Absent key = the full label is used.
    step_nav_eevc_co2e_report: "EEVC + CO2e Report",
    step_component_eevc: "EEVC",
    step_component_co2e_emissions_report: "CO2e Emissions Report",
    pipeline_status_not_started: "not started",
    pipeline_status_ready: "ready",
    pipeline_status_blocked: "blocked",
    pipeline_status_complete: "complete",
    pipeline_not_built: "Not built",
    pipeline_not_built_detail: "This step is part of the pipeline sequence but has not been built yet. Nothing runs and nothing is stored for it.",
    pipeline_runs_in_parallel: "Runs in parallel",
    pipeline_parallel_component_of: "parallel component of",
    pipeline_blocked_waiting_on: "Waiting on:",
    pipeline_reason_prerequisite_incomplete: "is not complete",
    pipeline_reason_prerequisite_no_cycle_complete: "has not completed a cycle yet",
    pipeline_prereq_satisfied: "satisfied",
    pipeline_prerequisites: "Prerequisites",
    pipeline_no_prerequisites: "This step has no prerequisites.",
    pipeline_soft_gating_note: "Prerequisites are reported, not enforced. Every step stays reachable.",
    pipeline_step_position: "Pipeline step",
    pipeline_internal_name: "internal name",
    // Pulse Sync (internally MB-PINN) never completes: it reports cycle
    // progress and a cycle count, never a done state.
    pulse_state_accumulating: "Accumulating — no validation yet",
    pulse_state_validated_training: "Validated · still training",
    pulse_cycles_complete: "Cycles complete",
    pulse_current_cycle: "Current cycle",
    pulse_cycle_coverage: "Cycle coverage",
    pulse_months: "months",
    pulse_state: "State",
    pulse_cycle_record: "Cycle record",
    pulse_never_completes_note: "Pulse Sync ingests continuously and has no completed state. The first completed cycle is the point at which output can be validated against the baseline; ingestion continues past it.",
    pulse_scaled_months: "Scaled months",
    pulse_no_scaled_months: "No scaled months recorded for this cycle.",
    pulse_values_were_scaled: "values were scaled",
    pulse_days_of_coverage: "days of coverage",
    // Audit Types
    commercial_audits: "Commercial Audits",
    residential_audits: "Residential Audits",
    residential_dashboard: "Residential Dashboard",
    residential_inventory: "Residential Inventory",
    residential_iot: "Residential IoT Data",
    residential_consolidated: "Residential Consolidated",
    select_residential_dept: "Select Residential Category",
    select_residential_subtitle: "Choose a residential category to audit. Mark categories as \"Not Applicable\" if they don't apply.",
    // Residential department names
    res_hvac: "HVAC Systems",
    res_insulation: "Insulation & Envelope",
    res_lighting: "Lighting",
    res_appliances: "Appliances",
    res_water_heating: "Water Heating",
  },
  fr: {
    app_name: "CO2ePortal",
    login: "Connexion",
    register: "S'inscrire",
    email: "Courriel",
    password: "Mot de passe",
    name: "Nom",
    logout: "Déconnexion",
    admin_panel: "Panneau Admin",
    back_to_clients: "Retour aux Clients",
    assets_title: "Actifs",
    assets_desc: "Gérez les bâtiments et propriétés de ce client. Chaque actif a ses propres données énergétiques et profil d'audit.",
    add_asset: "Ajouter un Actif",
    new_asset: "Nouvel Actif",
    edit_asset: "Modifier l'Actif",
    role_admin: "admin",
    role_auditor: "auditeur",
    select_client: "Sélectionner un Client",
    select_client_subtitle: "Choisissez un client pour commencer l'audit.",
    add_new_client: "Ajouter un Nouveau Client",
    no_clients_yet: "Aucun client pour le moment",
    create_first_client: "Créez votre premier client pour commencer.",
    company_name: "Nom de l'Entreprise",
    address: "Adresse",
    city: "Ville",
    zip_code: "Code Postal",
    country: "Pays",
    contact_name: "Nom du Contact",
    phone: "Téléphone",
    website: "Site Web",
    save: "Enregistrer",
    cancel: "Annuler",
    create_new_client: "Créer un Nouveau Client",
    select_department: "Sélectionner le Département à Auditer",
    select_department_subtitle: "Choisissez un département pour commencer ou continuer son audit. Marquez les départements comme \"Non Applicable\" s'ils ne s'appliquent pas à l'entreprise de ce client.",
    no_departments_title: "Aucun département pour ce bâtiment",
    no_departments_for_asset: "Aucun département n'est encore affecté à {asset}. Un département apparaît ici dès que des données d'inventaire ou de comptage sont enregistrées pour ce bâtiment.",
    no_departments_for_client: "Aucun département n'est encore affecté à ce client. Un département apparaît ici dès que des données d'inventaire ou de comptage sont enregistrées pour l'un de ses bâtiments.",
    not_applicable: "Non Applicable",
    not_started: "non commencé",
    in_progress: "en cours",
    completed: "terminé",
    complete: "Terminé",
    audit_progress: "Progression de l'Audit",
    depts: "dépts",
    depts_na: "dépt(s) N/A",
    main: "Principal",
    dashboard: "Tableau de Bord",
    inventory_upload: "Import Inventaire",
    energy_data_upload: "Téléversement Données Énergie",
    energy_data_upload_desc: "Téléversez les fichiers de facturation historique, d'analyse thermique et de facturation de gaz pour le pipeline de calibration DPB-INIT-EMS.",
    energy_vec_electrical: "Facturation Électrique Historique",
    energy_vec_electrical_desc: "Export de facturation Hydro-Québec (jusqu'à 12 mois) — source de repli/vérification croisée, distincte des données IoT en direct.",
    energy_vec_thermal: "Analyse Thermique du Bâtiment",
    energy_vec_thermal_desc: "Modèle énergétique théorique/simulé du bâtiment (enveloppe, CVC, consommation mensuelle).",
    energy_vec_gas: "Facturation Gaz — Énergir",
    energy_vec_gas_desc: "Données de factures Énergir avec périodes de facturation irrégulières — la seule source de données réelles pour le vecteur gaz.",
    energy_thermal_mapping_title: "Mappage des Colonnes Requis",
    energy_thermal_mapping_desc: "Sélectionnez les colonnes contenant le mois et la valeur théorique. Prévisualisez les premières lignes ci-dessous.",
    iot_data: "Données IoT",
    data_comparison: "Comparaison des Données",
    consolidated_results: "Résultats Consolidés",
    energy_report: "Rapport d'Efficacité Énergétique",
    co2_report: "Rapport d'Émissions CO2e",
    departments: "Départements",
    navigation: "Navigation",
    back: "Retour",
    audit: "Audit",
    save_all_answers: "Enregistrer Toutes les Réponses",
    saving: "Enregistrement...",
    questions_answered: "questions répondues",
    of: "sur",
    select_option: "-- Sélectionner --",
    yes: "Oui",
    no: "Non",
    enter_value: "Entrer une valeur...",
    enter_answer: "Entrez votre réponse...",
    dynamic: "Dynamique",
    energy_co2_title: "Estimation de l'Efficacité Énergétique et des Émissions CO2",
    energy_co2_empty: "Remplissez les questions numériques (kWh, kW) pour voir les estimations d'énergie et d'émissions en temps réel.",
    total_energy_kwh: "Énergie Totale (kWh)",
    total_power_kw: "Puissance Totale (kW)",
    est_co2_kg: "CO2 Estimé (kg)",
    hours_full_load: "Heures à Pleine Charge",
    breakdown_by_section: "Répartition par Section",
    section: "Section",
    energy_kwh: "Énergie (kWh)",
    power_kw: "Puissance (kW)",
    co2_kg: "CO2 (kg)",
    auditor_observations: "Observations de l'Auditeur",
    observations_subtitle: "Notes, conclusions et recommandations pour cet audit de département.",
    observations_placeholder: "Entrez les observations, notes ou recommandations pour cet audit de département...",
    upload_inventory: "Importer le Fichier d'Inventaire",
    upload_csv_xlsx: "Téléchargez un fichier CSV ou Excel avec les données d'inventaire.",
    select_department_label: "Sélectionner le Département",
    upload: "Importer",
    uploading: "Importation...",
    equipment: "Équipement",
    department: "Département",
    power_rating: "Puissance Nominale",
    energy_consumed: "Énergie Consommée",
    cost: "Coût",
    co2_emission: "Émission CO2",
    no_inventory: "Aucune donnée d'inventaire. Importez un fichier pour commencer.",
    iot_title: "Données IoT — Compteur PMC-53A-E",
    iot_subtitle: "Lectures simulées en temps réel des compteurs CET PMC-53A-E.",
    simulate: "Simuler les Lectures",
    simulating: "Simulation...",
    latest_readings: "Dernières Lectures",
    no_iot: "Aucune donnée IoT. Cliquez sur \"Simuler les Lectures\" pour générer des données PMC-53A-E.",
    comparison_title: "Tableau de Bord de Comparaison",
    comparison_subtitle: "Analyse à 3 voies : Fichier d'Inventaire vs IoT (PMC-53A-E) vs Résultats d'Audit",
    refresh: "Actualiser",
    no_discrepancies: "Aucune divergence significative détectée. Importez des données d'inventaire et simulez des lectures IoT pour activer la comparaison.",
    discrepancies_detected: "Divergence(s) Détectée(s)",
    high: "Élevé",
    medium: "Moyen",
    departments_compared: "Départements Comparés",
    discrepancies: "Divergences",
    high_severity: "Sévérité Élevée",
    inv_vs_iot_vs_audit: "Inventaire vs IoT vs Audit — Par Département",
    audit_pct: "Audit %",
    inv_energy: "Énergie Inv. (kWh)",
    inv_power: "Puiss. Inv. (kW)",
    iot_energy: "Énergie IoT (kWh)",
    iot_power: "Puiss. IoT (kW)",
    iot_pf: "FP IoT",
    iot_v_avg: "V IoT (moy)",
    energy_var: "Var. Énergie %",
    status: "Statut",
    alert: "Alerte",
    ok: "OK",
    energy_comparison_chart: "Comparaison Énergie : Inventaire vs IoT (kWh)",
    power_comparison_chart: "Puissance Active : Inventaire vs IoT (kW)",
    inventory: "Inventaire",
    iot_pmc: "IoT (PMC-53A-E)",
    inventory_kw: "Inventaire (kW)",
    iot_kw: "IoT (kW)",
    pmc_readings_title: "Lectures PMC-53A-E par Département",
    active_power: "Puissance Active",
    energy_total: "Énergie Totale",
    power_factor: "Facteur de Puissance",
    voltage_avg: "Tension (moy)",
    current_avg: "Courant (moy)",
    no_iot_readings: "Aucune lecture IoT — lancez la simulation",
    // Données Énergétiques (CEP)
    cep_title: "Données Énergétiques (CEP)",
    cep_subtitle: "Données de facturation et thermiques normalisées par mois civil pour ce bâtiment. Chaque vecteur conserve son unité — rien n'est additionné entre eux.",
    cep_no_data: "Aucune donnée énergétique n'a encore été traitée. Téléversez un fichier dans Téléversement des Données Énergétiques.",
    cep_electrical: "Électricité (facturée)",
    cep_gas: "Gaz (facturé)",
    cep_thermal: "Thermique (modélisé)",
    cep_coverage: "Couverture",
    cep_months: "mois",
    cep_peak_demand: "Puissance facturée maximale",
    cep_not_uploaded: "Non téléversé",
    cep_missing_electrical_months: "mois sans données électriques",
    cep_vector_absent: "Aucun fichier téléversé pour ce vecteur.",
    cep_by_building: "Par bâtiment",
    cep_co2_withheld: "CO2 issu de l'énergie mesurée",
    // Réconciliation ascendante
    recon_title: "Réconciliation Ascendante",
    recon_subtitle: "Les départements de ce bâtiment sont additionnés puis comparés au total mesuré du bâtiment. Il n'y a aucune répartition descendante.",
    recon_reference: "Total mesuré (CEP électrique)",
    recon_bottom_up: "Somme ascendante",
    recon_difference: "Écart",
    recon_ratio: "Rapport",
    recon_period: "Période de facturation",
    recon_basis: "Base",
    recon_not_comparable: "Non comparable",
    recon_not_comparable_note: "Affiché à titre arithmétique seulement. Les deux côtés ne mesurent pas la même chose : cet écart n'est pas traité comme une divergence et ne déclenche aucune alerte.",
    recon_inventory_vs_cep: "Inventaire vs mesuré",
    recon_iot_vs_cep: "IoT vs mesuré",
    recon_no_reference: "Aucun total électrique mesuré pour la comparaison.",
    recon_depts_counted: "départements additionnés",
    // Départements exclus
    excluded_title: "Exclus du tableau ci-dessus",
    excluded_subtitle: "Ces départements sont marqués Non Applicable pour le client : ils n'apparaissent donc pas comme lignes. Leurs données d'inventaire et de compteur SONT toutefois incluses dans la réconciliation ci-dessus, car le total mesuré du bâtiment les comprend.",
    excluded_has_data: "contient des données dans ce bâtiment",
    excluded_no_data: "aucune donnée dans ce bâtiment",
    excluded_counted: "Inclus dans la réconciliation",
    // Portée et mises en garde
    scope_building: "Ce bâtiment",
    scope_client: "Tous les bâtiments",
    scope_asset_note: "Les décomptes portent sur les départements du bâtiment sélectionné.",
    scope_client_note: "Les décomptes portent sur tous les départements de ce client.",
    audit_scope_note: "Le statut d'audit et Non Applicable sont enregistrés par client, non par bâtiment — le même département affiche le même statut dans chaque bâtiment.",
    na_scope_note: "Non Applicable est un indicateur au niveau du client. Un département marqué N/A est exclu du décompte de chaque bâtiment : ce dénominateur n'est donc pas un jugement sur ce bâtiment.",
    no_per_dept_energy: "Aucune valeur par département",
    reason_allocation_share_missing: "Aucune clé de répartition par département n'existe. La consommation mesurée d'un bâtiment ne peut être répartie entre ses départements sans elle, et aucune source vérifiée n'existe pour ces clés. La réconciliation est donc ascendante.",
    reason_emission_factor_unresolved: "Retenu : le facteur d'intensité du réseau n'est pas résolu et reste bloqué en attente d'une source vérifiée ; aucun chiffre de CO2 n'est donc dérivé de l'énergie mesurée.",
    reason_no_cep_data: "Aucune donnée énergétique n'a encore été traitée pour ce bâtiment.",
    reason_no_electrical_cep_data: "Aucune donnée de facturation électrique pour ce bâtiment. Les kWh électriques sont la seule quantité mesurée comparable aux sommes ascendantes — le gaz est en mètres cubes et le thermique est modélisé.",
    reason_inventory_period_undeclared: "L'énergie d'inventaire ne comporte aucune période. Les kWh de chaque ligne proviennent du fichier téléversé sans période de facturation associée : ils ne peuvent être rattachés aux mois mesurés.",
    reason_iot_register_snapshot: "L'énergie IoT est le dernier relevé du registre du compteur, non la consommation des mois mesurés : elle mesure donc une autre quantité que le total facturé.",
    consolidated_title: "Résultats Consolidés",
    consolidated_subtitle: "Analyse combinée de toutes les sources de données.",
    audits_completed: "Audits Terminés",
    equipment_items: "Équipements",
    total_energy: "Énergie Totale (kWh)",
    total_cost: "Coût Total",
    co2_emissions: "Émissions CO2 (kg)",
    audit_completion_dept: "Achèvement de l'Audit par Département",
    completion: "Achèvement",
    avg_iot_power: "Puiss. Moy. IoT (kW)",
    energy_by_dept: "Énergie par Département",
    co2_by_dept: "CO2 par Département",
    energy_report_title: "Rapport d'Efficacité Énergétique",
    energy_report_subtitle: "Consommation d'énergie, puissances nominales et analyse d'efficacité pour tous les départements.",
    co2_report_title: "Rapport d'Émissions CO2e",
    co2_report_subtitle: "Analyse de l'empreinte carbone, facteurs d'émission et évaluation de l'impact environnemental.",
    generated: "Généré le",
    download_report: "Télécharger le Rapport",
    download_excel: "Télécharger le Rapport Excel",
    client_information: "Informations Client",
    company: "Entreprise",
    contact: "Contact",
    dept_overview: "Aperçu par Département",
    recommendations: "Recommandations",
    energy_metrics: "Métriques Énergétiques",
    efficiency_analysis: "Analyse d'Efficacité",
    emission_breakdown: "Répartition des Émissions",
    total_carbon_footprint: "Empreinte Carbone Totale",
    dept_emissions: "Émissions par Département",
    alerts: "Alertes",
    threshold_alerts: "Alertes de Seuil",
    no_alerts: "Toutes les métriques sont dans les seuils acceptables.",
    alert_pf_low: "Facteur de puissance sous le seuil",
    alert_energy_high: "Consommation d'énergie dépasse le seuil",
    alert_co2_high: "Émissions CO2 dépassent le seuil",
    threshold_settings: "Paramètres de Seuil",
    pf_threshold: "Facteur de Puissance Min.",
    energy_threshold: "Énergie Max. (kWh)",
    co2_threshold: "CO2 Max. (kg)",
    save_thresholds: "Enregistrer les Seuils",
    sensor_readings: "Lectures des Capteurs",
    upload_data: "Import des Données",
    meters: "Compteurs",
    no_meters: "Aucun compteur PMC-53A-E détecté. Simulez des données ou importez un fichier.",
    source: "Source",
    readings: "Lectures",
    last_reading: "Dernière Lecture",
    drop_pmc_file: "Déposez le fichier d'export PMC-53A-E ici ou cliquez pour parcourir",
    pmc_register_map: "Noms de colonnes acceptés PMC-53A-E",
    click_simulate: "Cliquez sur « Simuler » pour générer des lectures",
    live_monitor: "Moniteur en Direct",
    all_departments: "Tous les Départements",
    pause: "Pause",
    resume: "Reprendre",
    last_update: "Dernière mise à jour",
    data_points: "points de données",
    current_values: "Valeurs Actuelles",
    voltage_phase: "Tension (Triphasé)",
    current_phase: "Courant (Triphasé)",
    power_metrics: "Métriques de Puissance",
    quality_metrics: "Qualité de l'Énergie",
    energy_trend: "Tendance de Consommation",
    harmonic_distortion: "Distorsion Harmonique",
    no_timeseries: "Aucune donnée de séries temporelles disponible",
    simulate_or_push: "Simulez des données ou envoyez des lectures PMC-53A-E pour voir les tendances.",
    // Pipeline commercial — voir la note côté EN pour le schéma des clés.
    step_dashboard: "Tableau de Bord",
    step_inventory_upload: "Import Inventaire",
    step_energy_data_upload: "Téléversement Données Énergie",
    step_retscreen_validation: "Validation RETScreen",
    step_iot_data: "Données IoT",
    step_mb_pinn: "Pulse Sync",
    step_data_comparison: "Comparaison des Données",
    step_consolidated_results: "Résultats Consolidés",
    step_sire: "SIRE",
    step_eevc_co2e_report: "EEVC + Rapport d'Émissions CO2e",
    step_nav_eevc_co2e_report: "EEVC + Rapport CO2e",
    step_component_eevc: "EEVC",
    step_component_co2e_emissions_report: "Rapport d'Émissions CO2e",
    pipeline_status_not_started: "non démarré",
    pipeline_status_ready: "prêt",
    pipeline_status_blocked: "bloqué",
    pipeline_status_complete: "terminé",
    pipeline_not_built: "Non développé",
    pipeline_not_built_detail: "Cette étape fait partie de la séquence du pipeline mais n'a pas encore été développée. Rien ne s'exécute et rien n'est enregistré pour elle.",
    pipeline_runs_in_parallel: "Exécution en parallèle",
    pipeline_parallel_component_of: "composant parallèle de",
    pipeline_blocked_waiting_on: "En attente de :",
    pipeline_reason_prerequisite_incomplete: "n'est pas terminé",
    pipeline_reason_prerequisite_no_cycle_complete: "n'a pas encore terminé de cycle",
    pipeline_prereq_satisfied: "satisfait",
    pipeline_prerequisites: "Prérequis",
    pipeline_no_prerequisites: "Cette étape n'a aucun prérequis.",
    pipeline_soft_gating_note: "Les prérequis sont signalés, non imposés. Chaque étape reste accessible.",
    pipeline_step_position: "Étape du pipeline",
    pipeline_internal_name: "nom interne",
    pulse_state_accumulating: "Accumulation — aucune validation pour l'instant",
    pulse_state_validated_training: "Validé · entraînement en cours",
    pulse_cycles_complete: "Cycles terminés",
    pulse_current_cycle: "Cycle en cours",
    pulse_cycle_coverage: "Couverture du cycle",
    pulse_months: "mois",
    pulse_state: "État",
    pulse_cycle_record: "Enregistrement du cycle",
    pulse_never_completes_note: "Pulse Sync ingère les données en continu et n'a pas d'état terminé. Le premier cycle terminé est le moment où les résultats peuvent être validés par rapport à la référence ; l'ingestion se poursuit ensuite.",
    pulse_scaled_months: "Mois mis à l'échelle",
    pulse_no_scaled_months: "Aucun mois mis à l'échelle pour ce cycle.",
    pulse_values_were_scaled: "valeurs mises à l'échelle",
    pulse_days_of_coverage: "jours de couverture",
    commercial_audits: "Audits Commerciaux",
    residential_audits: "Audits Résidentiels",
    residential_dashboard: "Tableau de Bord Résidentiel",
    residential_inventory: "Inventaire Résidentiel",
    residential_iot: "Données IoT Résidentielles",
    residential_consolidated: "Résultats Résidentiels",
    select_residential_dept: "Sélectionner une Catégorie Résidentielle",
    select_residential_subtitle: "Choisissez une catégorie résidentielle à auditer.",
    res_hvac: "Systèmes CVC",
    res_insulation: "Isolation & Enveloppe",
    res_lighting: "Éclairage",
    res_appliances: "Appareils",
    res_water_heating: "Chauffe-eau",
  },
  es: {
    app_name: "CO2ePortal",
    login: "Iniciar Sesión",
    register: "Registrarse",
    email: "Correo Electrónico",
    password: "Contraseña",
    name: "Nombre",
    logout: "Cerrar Sesión",
    admin_panel: "Panel de Admin",
    back_to_clients: "Volver a Clientes",
    assets_title: "Activos",
    assets_desc: "Gestione edificios y propiedades de este cliente. Cada activo tiene sus propios datos energéticos y perfil de auditoría.",
    add_asset: "Agregar Activo",
    new_asset: "Nuevo Activo",
    edit_asset: "Editar Activo",
    role_admin: "admin",
    role_auditor: "auditor",
    select_client: "Seleccionar un Cliente",
    select_client_subtitle: "Elija un cliente para comenzar la auditoría.",
    add_new_client: "Agregar Nuevo Cliente",
    no_clients_yet: "Aún no hay clientes",
    create_first_client: "Cree su primer cliente para comenzar.",
    company_name: "Nombre de la Empresa",
    address: "Dirección",
    city: "Ciudad",
    zip_code: "Código Postal",
    country: "País",
    contact_name: "Nombre del Contacto",
    phone: "Teléfono",
    website: "Sitio Web",
    save: "Guardar",
    cancel: "Cancelar",
    create_new_client: "Crear Nuevo Cliente",
    select_department: "Seleccionar Departamento a Auditar",
    select_department_subtitle: "Elija un departamento para comenzar o continuar su auditoría. Marque los departamentos como \"No Aplicable\" si no aplican al negocio de este cliente.",
    no_departments_title: "Ningún departamento para este edificio",
    no_departments_for_asset: "Aún no hay departamentos asignados a {asset}. Un departamento aparece aquí en cuanto se registran datos de inventario o de medición para este edificio.",
    no_departments_for_client: "Aún no hay departamentos asignados a este cliente. Un departamento aparece aquí en cuanto se registran datos de inventario o de medición para uno de sus edificios.",
    not_applicable: "No Aplicable",
    not_started: "no iniciado",
    in_progress: "en progreso",
    completed: "completado",
    complete: "Completado",
    audit_progress: "Progreso de Auditoría",
    depts: "deptos",
    depts_na: "depto(s) N/A",
    main: "Principal",
    dashboard: "Panel Principal",
    inventory_upload: "Carga de Inventario",
    energy_data_upload: "Carga de Datos Energéticos",
    energy_data_upload_desc: "Cargue archivos de facturación histórica, análisis térmico y facturación de gas para el pipeline de calibración DPB-INIT-EMS.",
    energy_vec_electrical: "Facturación Eléctrica Histórica",
    energy_vec_electrical_desc: "Exportación de facturación Hydro-Québec (hasta 12 meses) — fuente de respaldo/verificación cruzada, distinta de los datos IoT en vivo.",
    energy_vec_thermal: "Análisis Térmico del Edificio",
    energy_vec_thermal_desc: "Modelo energético teórico/simulado del edificio (envolvente, HVAC, consumo mensual).",
    energy_vec_gas: "Facturación de Gas — Énergir",
    energy_vec_gas_desc: "Datos de facturas Énergir con períodos de facturación irregulares — la única fuente de datos reales para el vector de gas.",
    energy_thermal_mapping_title: "Mapeo de Columnas Requerido",
    energy_thermal_mapping_desc: "Seleccione las columnas que contienen el mes y el valor teórico. Previsualice las primeras filas a continuación.",
    iot_data: "Datos IoT",
    data_comparison: "Comparación de Datos",
    consolidated_results: "Resultados Consolidados",
    energy_report: "Informe de Eficiencia Energética",
    co2_report: "Informe de Emisiones CO2e",
    departments: "Departamentos",
    navigation: "Navegación",
    back: "Volver",
    audit: "Auditoría",
    save_all_answers: "Guardar Todas las Respuestas",
    saving: "Guardando...",
    questions_answered: "preguntas respondidas",
    of: "de",
    select_option: "-- Seleccionar --",
    yes: "Sí",
    no: "No",
    enter_value: "Ingrese un valor...",
    enter_answer: "Ingrese su respuesta...",
    dynamic: "Dinámico",
    energy_co2_title: "Estimación de Eficiencia Energética y Emisiones CO2",
    energy_co2_empty: "Complete las preguntas numéricas (kWh, kW) para ver estimaciones de energía y emisiones en tiempo real.",
    total_energy_kwh: "Energía Total (kWh)",
    total_power_kw: "Potencia Total (kW)",
    est_co2_kg: "CO2 Estimado (kg)",
    hours_full_load: "Horas a Plena Carga",
    breakdown_by_section: "Desglose por Sección",
    section: "Sección",
    energy_kwh: "Energía (kWh)",
    power_kw: "Potencia (kW)",
    co2_kg: "CO2 (kg)",
    auditor_observations: "Observaciones del Auditor",
    observations_subtitle: "Notas, hallazgos y recomendaciones para esta auditoría de departamento.",
    observations_placeholder: "Ingrese observaciones, notas o recomendaciones para esta auditoría de departamento...",
    upload_inventory: "Cargar Archivo de Inventario",
    upload_csv_xlsx: "Suba un archivo CSV o Excel con datos de inventario.",
    select_department_label: "Seleccionar Departamento",
    upload: "Cargar",
    uploading: "Cargando...",
    equipment: "Equipo",
    department: "Departamento",
    power_rating: "Potencia Nominal",
    energy_consumed: "Energía Consumida",
    cost: "Costo",
    co2_emission: "Emisión CO2",
    no_inventory: "Sin datos de inventario. Suba un archivo para comenzar.",
    iot_title: "Datos IoT — Medidor PMC-53A-E",
    iot_subtitle: "Lecturas simuladas en tiempo real de medidores CET PMC-53A-E.",
    simulate: "Simular Lecturas",
    simulating: "Simulando...",
    latest_readings: "Últimas Lecturas",
    no_iot: "Sin datos IoT. Haga clic en \"Simular Lecturas\" para generar datos PMC-53A-E.",
    comparison_title: "Panel de Comparación de Datos",
    comparison_subtitle: "Análisis de 3 vías: Archivo de Inventario vs IoT (PMC-53A-E) vs Resultados de Auditoría",
    refresh: "Actualizar",
    no_discrepancies: "No se detectaron discrepancias significativas. Suba datos de inventario y simule lecturas IoT para habilitar la comparación.",
    discrepancies_detected: "Discrepancia(s) Detectada(s)",
    high: "Alto",
    medium: "Medio",
    departments_compared: "Departamentos Comparados",
    discrepancies: "Discrepancias",
    high_severity: "Severidad Alta",
    inv_vs_iot_vs_audit: "Inventario vs IoT vs Auditoría — Por Departamento",
    audit_pct: "Auditoría %",
    inv_energy: "Energía Inv. (kWh)",
    inv_power: "Pot. Inv. (kW)",
    iot_energy: "Energía IoT (kWh)",
    iot_power: "Pot. IoT (kW)",
    iot_pf: "FP IoT",
    iot_v_avg: "V IoT (prom)",
    energy_var: "Var. Energía %",
    status: "Estado",
    alert: "Alerta",
    ok: "OK",
    energy_comparison_chart: "Comparación Energía: Inventario vs IoT (kWh)",
    power_comparison_chart: "Potencia Activa: Inventario vs IoT (kW)",
    inventory: "Inventario",
    iot_pmc: "IoT (PMC-53A-E)",
    inventory_kw: "Inventario (kW)",
    iot_kw: "IoT (kW)",
    pmc_readings_title: "Lecturas PMC-53A-E por Departamento",
    active_power: "Potencia Activa",
    energy_total: "Energía Total",
    power_factor: "Factor de Potencia",
    voltage_avg: "Voltaje (prom)",
    current_avg: "Corriente (prom)",
    no_iot_readings: "Sin lecturas IoT — ejecute la simulación",
    // Datos Energéticos (CEP)
    cep_title: "Datos Energéticos (CEP)",
    cep_subtitle: "Datos de facturación y térmicos normalizados por mes calendario para este edificio. Cada vector conserva su unidad — nada se suma entre ellos.",
    cep_no_data: "Aún no se han procesado datos energéticos. Cargue un archivo en Carga de Datos Energéticos.",
    cep_electrical: "Eléctrico (facturado)",
    cep_gas: "Gas (facturado)",
    cep_thermal: "Térmico (modelado)",
    cep_coverage: "Cobertura",
    cep_months: "meses",
    cep_peak_demand: "Demanda facturada máxima",
    cep_not_uploaded: "No cargado",
    cep_missing_electrical_months: "meses sin datos eléctricos",
    cep_vector_absent: "No se ha cargado ningún archivo para este vector.",
    cep_by_building: "Por edificio",
    cep_co2_withheld: "CO2 a partir de la energía medida",
    // Reconciliación ascendente
    recon_title: "Reconciliación Ascendente",
    recon_subtitle: "Los departamentos de este edificio se suman y se comparan con el total medido del edificio. No hay reparto descendente.",
    recon_reference: "Total medido (CEP eléctrico)",
    recon_bottom_up: "Suma ascendente",
    recon_difference: "Diferencia",
    recon_ratio: "Razón",
    recon_period: "Período de facturación",
    recon_basis: "Base",
    recon_not_comparable: "No comparable",
    recon_not_comparable_note: "Se muestra solo como aritmética. Los dos lados miden cosas distintas, por lo que esta diferencia no se trata como discrepancia y no genera ninguna alerta.",
    recon_inventory_vs_cep: "Inventario vs medido",
    recon_iot_vs_cep: "IoT vs medido",
    recon_no_reference: "No hay total eléctrico medido con el que comparar.",
    recon_depts_counted: "departamentos sumados",
    // Departamentos excluidos
    excluded_title: "Excluidos de la tabla anterior",
    excluded_subtitle: "Estos departamentos están marcados como No Aplicable para el cliente, por lo que no se muestran como filas. Sus datos de inventario y de medidor SÍ se cuentan en la reconciliación anterior, porque el total medido del edificio los incluye.",
    excluded_has_data: "tiene datos en este edificio",
    excluded_no_data: "sin datos en este edificio",
    excluded_counted: "Incluido en la reconciliación",
    // Alcance y advertencias
    scope_building: "Este edificio",
    scope_client: "Todos los edificios",
    scope_asset_note: "Los recuentos abarcan los departamentos del edificio seleccionado.",
    scope_client_note: "Los recuentos abarcan todos los departamentos de este cliente.",
    audit_scope_note: "El estado de auditoría y No Aplicable se registran por cliente, no por edificio — el mismo departamento muestra el mismo estado en cada edificio.",
    na_scope_note: "No Aplicable es un indicador a nivel de cliente. Un departamento marcado como N/A se excluye del recuento de cada edificio, por lo que este denominador no es un juicio sobre este edificio.",
    no_per_dept_energy: "Sin valor por departamento",
    reason_allocation_share_missing: "No existe ninguna clave de reparto por departamento. El consumo medido de un edificio no puede dividirse entre sus departamentos sin ella, y no existe fuente verificada para esas claves. La reconciliación se realiza de forma ascendente.",
    reason_emission_factor_unresolved: "Retenido: el factor de intensidad de la red no está resuelto y permanece bloqueado a la espera de una fuente verificada, por lo que no se deriva ninguna cifra de CO2 de la energía medida.",
    reason_no_cep_data: "Aún no se han procesado datos energéticos para este edificio.",
    reason_no_electrical_cep_data: "No hay datos de facturación eléctrica para este edificio. Los kWh eléctricos son la única cantidad medida comparable con las sumas ascendentes — el gas está en metros cúbicos y el térmico es modelado.",
    reason_inventory_period_undeclared: "La energía de inventario no lleva ningún período. Los kWh de cada fila provienen del archivo cargado sin una ventana de facturación asociada, por lo que no pueden vincularse a los meses medidos.",
    reason_iot_register_snapshot: "La energía IoT es la última lectura del registro del medidor, no el consumo durante los meses medidos, por lo que mide una cantidad distinta del total facturado.",
    consolidated_title: "Resultados Consolidados",
    consolidated_subtitle: "Análisis combinado de todas las fuentes de datos.",
    audits_completed: "Auditorías Completadas",
    equipment_items: "Equipos",
    total_energy: "Energía Total (kWh)",
    total_cost: "Costo Total",
    co2_emissions: "Emisiones CO2 (kg)",
    audit_completion_dept: "Avance de Auditoría por Departamento",
    completion: "Avance",
    avg_iot_power: "Pot. Prom. IoT (kW)",
    energy_by_dept: "Energía por Departamento",
    co2_by_dept: "CO2 por Departamento",
    energy_report_title: "Informe de Eficiencia Energética",
    energy_report_subtitle: "Consumo de energía, potencias nominales y análisis de eficiencia para todos los departamentos.",
    co2_report_title: "Informe de Emisiones CO2e",
    co2_report_subtitle: "Análisis de huella de carbono, factores de emisión y evaluación de impacto ambiental.",
    generated: "Generado el",
    download_report: "Descargar Informe",
    download_excel: "Descargar Informe Excel",
    client_information: "Información del Cliente",
    company: "Empresa",
    contact: "Contacto",
    dept_overview: "Resumen por Departamento",
    recommendations: "Recomendaciones",
    energy_metrics: "Métricas Energéticas",
    efficiency_analysis: "Análisis de Eficiencia",
    emission_breakdown: "Desglose de Emisiones",
    total_carbon_footprint: "Huella de Carbono Total",
    dept_emissions: "Emisiones por Departamento",
    alerts: "Alertas",
    threshold_alerts: "Alertas de Umbral",
    no_alerts: "Todas las métricas dentro de umbrales aceptables.",
    alert_pf_low: "Factor de potencia por debajo del umbral",
    alert_energy_high: "Consumo de energía excede el umbral",
    alert_co2_high: "Emisiones CO2 exceden el umbral",
    threshold_settings: "Configuración de Umbrales",
    pf_threshold: "Factor de Potencia Mín.",
    energy_threshold: "Energía Máx. (kWh)",
    co2_threshold: "CO2 Máx. (kg)",
    save_thresholds: "Guardar Umbrales",
    sensor_readings: "Lecturas de Sensores",
    upload_data: "Carga de Datos",
    meters: "Medidores",
    no_meters: "No se detectaron medidores PMC-53A-E. Simule datos o cargue un archivo de exportación.",
    source: "Fuente",
    readings: "Lecturas",
    last_reading: "Última Lectura",
    drop_pmc_file: "Suelte el archivo de exportación PMC-53A-E aquí o haga clic para explorar",
    pmc_register_map: "Nombres de columnas aceptados PMC-53A-E",
    click_simulate: "Haga clic en \"Simular\" para generar lecturas",
    live_monitor: "Monitor en Vivo",
    all_departments: "Todos los Departamentos",
    pause: "Pausar",
    resume: "Reanudar",
    last_update: "Última actualización",
    data_points: "puntos de datos",
    current_values: "Valores Actuales",
    voltage_phase: "Voltaje (Trifásico)",
    current_phase: "Corriente (Trifásica)",
    power_metrics: "Métricas de Potencia",
    quality_metrics: "Calidad de Energía",
    energy_trend: "Tendencia de Consumo",
    harmonic_distortion: "Distorsión Armónica",
    no_timeseries: "No hay datos de series temporales disponibles",
    simulate_or_push: "Simule datos o envíe lecturas PMC-53A-E para ver tendencias en vivo.",
    // Pipeline comercial — ver la nota en EN sobre el esquema de claves.
    step_dashboard: "Panel Principal",
    step_inventory_upload: "Carga de Inventario",
    step_energy_data_upload: "Carga de Datos Energéticos",
    step_retscreen_validation: "Validación RETScreen",
    step_iot_data: "Datos IoT",
    step_mb_pinn: "Pulse Sync",
    step_data_comparison: "Comparación de Datos",
    step_consolidated_results: "Resultados Consolidados",
    step_sire: "SIRE",
    step_eevc_co2e_report: "EEVC + Informe de Emisiones CO2e",
    step_nav_eevc_co2e_report: "EEVC + Informe CO2e",
    step_component_eevc: "EEVC",
    step_component_co2e_emissions_report: "Informe de Emisiones CO2e",
    pipeline_status_not_started: "sin iniciar",
    pipeline_status_ready: "listo",
    pipeline_status_blocked: "bloqueado",
    pipeline_status_complete: "completado",
    pipeline_not_built: "No desarrollado",
    pipeline_not_built_detail: "Esta etapa forma parte de la secuencia del pipeline pero aún no ha sido desarrollada. No se ejecuta nada ni se almacena nada para ella.",
    pipeline_runs_in_parallel: "Se ejecutan en paralelo",
    pipeline_parallel_component_of: "componente paralelo de",
    pipeline_blocked_waiting_on: "En espera de:",
    pipeline_reason_prerequisite_incomplete: "no está completado",
    pipeline_reason_prerequisite_no_cycle_complete: "aún no ha completado un ciclo",
    pipeline_prereq_satisfied: "satisfecho",
    pipeline_prerequisites: "Requisitos previos",
    pipeline_no_prerequisites: "Esta etapa no tiene requisitos previos.",
    pipeline_soft_gating_note: "Los requisitos previos se informan, no se imponen. Todas las etapas siguen siendo accesibles.",
    pipeline_step_position: "Etapa del pipeline",
    pipeline_internal_name: "nombre interno",
    pulse_state_accumulating: "Acumulando — aún sin validación",
    pulse_state_validated_training: "Validado · sigue entrenando",
    pulse_cycles_complete: "Ciclos completados",
    pulse_current_cycle: "Ciclo actual",
    pulse_cycle_coverage: "Cobertura del ciclo",
    pulse_months: "meses",
    pulse_state: "Estado",
    pulse_cycle_record: "Registro del ciclo",
    pulse_never_completes_note: "Pulse Sync ingiere datos de forma continua y no tiene un estado completado. El primer ciclo completado es el momento en que los resultados pueden validarse contra la línea base; la ingesta continúa después.",
    pulse_scaled_months: "Meses escalados",
    pulse_no_scaled_months: "No hay meses escalados registrados para este ciclo.",
    pulse_values_were_scaled: "valores escalados",
    pulse_days_of_coverage: "días de cobertura",
    commercial_audits: "Auditorías Comerciales",
    residential_audits: "Auditorías Residenciales",
    residential_dashboard: "Panel Residencial",
    residential_inventory: "Inventario Residencial",
    residential_iot: "Datos IoT Residenciales",
    residential_consolidated: "Resultados Residenciales",
    select_residential_dept: "Seleccionar Categoría Residencial",
    select_residential_subtitle: "Elija una categoría residencial para auditar.",
    res_hvac: "Sistemas HVAC",
    res_insulation: "Aislamiento y Envolvente",
    res_lighting: "Iluminación",
    res_appliances: "Electrodomésticos",
    res_water_heating: "Calentamiento de Agua",
  }
};

// Department name translations
const deptNames = {
  en: {
    building_facilities: "Building & Facilities",
    operations_equipment: "Operations & Equipment",
    transportation_logistics: "Transportation & Logistics",
    procurement_waste: "Procurement & Waste",
    administrative: "Administrative",
    it_infrastructure: "IT Infrastructure",
    res_hvac: "HVAC Systems",
    res_insulation: "Insulation & Envelope",
    res_lighting: "Lighting",
    res_appliances: "Appliances",
    res_water_heating: "Water Heating",
  },
  fr: {
    building_facilities: "Bâtiments et Installations",
    operations_equipment: "Opérations et Équipements",
    transportation_logistics: "Transport et Logistique",
    procurement_waste: "Approvisionnement et Déchets",
    administrative: "Administratif",
    it_infrastructure: "Infrastructure Informatique",
    res_hvac: "Systèmes CVC",
    res_insulation: "Isolation et Enveloppe",
    res_lighting: "Éclairage",
    res_appliances: "Appareils Électroménagers",
    res_water_heating: "Chauffe-eau",
  },
  es: {
    building_facilities: "Edificios e Instalaciones",
    operations_equipment: "Operaciones y Equipos",
    transportation_logistics: "Transporte y Logística",
    procurement_waste: "Adquisiciones y Residuos",
    administrative: "Administrativo",
    it_infrastructure: "Infraestructura de TI",
    res_hvac: "Sistemas HVAC",
    res_insulation: "Aislamiento y Envolvente",
    res_lighting: "Iluminación",
    res_appliances: "Electrodomésticos",
    res_water_heating: "Calentamiento de Agua",
  }
};

export { translations, deptNames };
